(function(){
    'use strict';
/*
    if (document.body.classList.contains('no-react')) {

        var chat_wrapper = document.querySelector('.chatbot__wrapper');
        var chat_click = document.querySelector('.chatbot__toggle-btn');
        var chat_close = document.querySelector('.chatbot__close');
        
        if (chat_click) {
            chat_click.addEventListener('click', toggleChatWindow);
        }

        if (chat_close) {
            chat_close.addEventListener('click', toggleChatWindow);
        }

        function toggleChatWindow() {
            chat_wrapper.classList.toggle('expanded');
        }
       
    }
*/    
}());
